import './DialogSpinner.scss';

import { ProgressSpinner } from 'primereact/progressspinner';

function DialogSpinner(): JSX.Element {
  return (
    <ProgressSpinner
      fill="#ccc"
      strokeWidth="4"
      className="dialog-progress-spinner"
    />
  );
}

export default DialogSpinner;
